/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

var jQuery = require("jquery");

global.$ = global.jQuery = jQuery;
window.$ = window.jquery = jQuery;

import Chart from 'chart.js/dist/Chart';
global.Chart = Chart;
import flatpickr from 'flatpickr/dist/flatpickr';
global.flatpickr=flatpickr
window.Chart = Chart

require("@popperjs/core")
require("bootstrap")
require("select2")
require("./dashboard")
require("./content_billing")
require("./advertise/dashboard")


// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

const trkDatatables = require('trk_datatables')

if (!window.__appClientLoaded) {
    window.__appClientLoaded = true;

    require('@hotwired/turbo');
}
import "controllers"
Turbo.setConfirmMethod((message, element) => {
    let dialog = document.getElementById("turbo-confirm")
    dialog.querySelector("p").textContent = message
    dialog.showModal()

    return new Promise((resolve, reject) => {
        dialog.addEventListener("close", () => {
            resolve(dialog.returnValue == "confirm")
        }, { once: true })
    })
})

document.addEventListener('turbo:render', () => {
    render_dataTable();
    ReactRailsUJS.mountComponents()
    $('.trk-move-up ').css('margin-top', '-40px');
})

document.addEventListener('turbo:before-fetch-request', (event) => {
    const fetchRequest = event.detail?.fetchRequest;  
    if (!fetchRequest || !fetchRequest.url) {
      return;
    }
    // console.log('turbo:before-fetch-request:', fetchRequest.url);
    console.log('turbo:before-visit');
    $('.overlay, body').removeClass('loaded');
    $('.overlay').show();
  });
  
document.addEventListener('turbo:before-stream-render', () => {
    $('.overlay, body').addClass('loaded');
    $('.overlay').css({'display':'none'})
})
document.addEventListener('turbo:frame-render', (event) => {
    // A popup/modal (move, copy-to-shared, bulk edit, etc.) renders its
    // content into the "remote_modal" turbo frame. render_dataTable() clears
    // every checkbox and the selection state (see its top), so opening a popup
    // would wipe the rows the user just selected. Snapshot the selection first
    // and restore it afterwards so it survives the popup on the layouts,
    // playlists, schedules, displays and tags pages.
    var isModalFrame = event && event.target && event.target.id === 'remote_modal';
    var preservedBoxesChecked, preservedIds;
    if (isModalFrame) {
      preservedBoxesChecked = $("input#boxes_checked").val();
      preservedIds = (window.__dtSelectedIds || []).slice();
      $('.row-checkbox:checked').each(function() {
        var id = $(this).val();
        if (preservedIds.indexOf(id) === -1) preservedIds.push(id);
      });
    }

    render_dataTable();

    if (isModalFrame) {
      window.__dtSelectedIds = preservedIds;
      $("input#boxes_checked").val(preservedBoxesChecked);
      $('table.DataTable tbody .row-checkbox').each(function() {
        if (preservedIds.indexOf($(this).val()) !== -1) {
          $(this).prop('checked', true);
        }
      });
      if (preservedBoxesChecked === 'true') {
        $('#toggle-all-rows').prop('checked', true);
      }
      if ($('.row-checkbox:checked').length > 0) {
        $('.btn-action').attr('disabled', false);
      }
    }

    ReactRailsUJS.mountComponents()
    $('.trk-move-up ').css('margin-top', '-40px');
    if ($('input#search_id').length){
        searchBarCursorPosition();
      }

})
document.addEventListener('DOMContentLoaded', () => {
    render_dataTable();
})


function render_dataTable(){
  window.__dtSelectedIds = [];
  window.__dtPreservedCheckedIds = [];
  $("input#boxes_checked").val('false');
  $('.row-checkbox, #toggle-all-rows, [data-enable-buttons]').prop('checked', false);
  $('.btn-action').attr('disabled', true);
    if (window.location.href.includes('displays'))
      {    
        trkDatatables.initialise({
            order: [[1, 'desc']],
            lengthMenu: [10, 20, 50, 100],        // scrollY: true,
            scrollX: false,
            pagingType: 'simple',
            oLanguage: {
                search: '',
                searchPlaceholder: 'Search...',
                info: 'Showing _START_ to _END_ of _TOTAL_ entries',
                lengthMenu: 'Show entries _MENU_',     
                infoFiltered: "" ,   
                paginate: {
                    next: '<i class="fa fa-angle-right">',
                    previous: '<i class="fa fa-angle-left">' ,
                }
            },
            dom: '<"trk-global-search-wrapper"f>rtp<"trk-move-up"li>'
        })
    } else
    {
      trkDatatables.initialise({
            lengthMenu: [10, 20, 50, 100],        // scrollY: true,
            scrollX: false,
            pagingType: 'simple',
            oLanguage: {
                search: '',
                searchPlaceholder: 'Search...',
                info: 'Showing _START_ to _END_ of _TOTAL_ entries',
                lengthMenu: 'Show entries _MENU_',     
                infoFiltered: "" ,   
                paginate: {
                    next: '<i class="fa fa-angle-right">',
                    previous: '<i class="fa fa-angle-left">' ,
                }
            },
            dom: '<"trk-global-search-wrapper"f>rtp<"trk-move-up"li>'
        })  
    }  
    var checkd_checkboxes = 0;
    $("#toggle-all-rows").off('click.trkDtToggle').on('click.trkDtToggle', function() {
        var all_checkboxes;
        all_checkboxes = $("[data-enable-buttons]");
        if (checkd_checkboxes > 0) {
            checkd_checkboxes = 0
            $("input#boxes_checked").val(false)
            window.__dtSelectedIds = [];
            return all_checkboxes.prop("checked", false);
        } else {
            $("input#boxes_checked").val(true)
            all_checkboxes.prop("checked", true);
            // Mirror the visible row IDs into the global selection set so
            // subsequent individual unchecks (which flip boxes_checked to
            // 'false') leave a correct partial state behind.
            window.__dtSelectedIds = $('.row-checkbox').map(function() {
              return $(this).val();
            }).get();
            checkd_checkboxes = all_checkboxes.length
            return
        }
    });

    $(document).off('click.trkDtEnable', '[data-enable-buttons]').on('click.trkDtEnable', '[data-enable-buttons]', function(e) {
        var $target;
        $target = $($(e.currentTarget).data().enableButtons);
        return checkIfEnableButtons($target);
    });

  $('#shareRecipeModal').off('hidden.bs.modal.trkDtResync').on('hidden.bs.modal.trkDtResync', function () {
    $('select[data-select2-initialize="true"]').each(function() {
      if ($.fn.select2 && $(this).hasClass('select2-hidden-accessible')) {
        $(this).select2('destroy');
      }
      $(this).select2({ closeOnSelect: false, minimumResultsForSearch: 0 });
    });
      const $mainTable = $('table.DataTable').first();
      if (!$mainTable.length || !$.fn.dataTable.isDataTable($mainTable[0])) {
        return;
      }
      const oldTable = $mainTable.DataTable();
        const globalSearch = oldTable.search();
        const columnSearch = [];
        oldTable.columns().every(function(index) {
          columnSearch[index] = this.search();
        });
      const pageLen = oldTable.page.len();
      const pageIndex = oldTable.page.info().page;
      // Keep trk_datatables in sync on re-init (findOptions uses $table.data('datatablePageLength'))
      $mainTable.attr('data-datatable-page-length', pageLen);
      $mainTable.data('datatablePageLength', pageLen);
      // Sync the table's AJAX URL with content_ids[] currently in the address bar
      // so closing a modal reloads the table filtered to whatever the URL says.
      const existingAjaxUrl = $mainTable.data('datatableAjaxUrl');
      if (existingAjaxUrl) {
        try {
          const ajaxUrl = new URL(existingAjaxUrl, window.location.origin);
          const pageContentIds = new URLSearchParams(window.location.search).getAll('content_ids[]');
          ajaxUrl.searchParams.delete('content_ids[]');
          pageContentIds.forEach(id => ajaxUrl.searchParams.append('content_ids[]', id));
          const updatedAjaxUrl = ajaxUrl.toString();
          $mainTable.attr('data-datatable-ajax-url', updatedAjaxUrl);
          $mainTable.data('datatableAjaxUrl', updatedAjaxUrl);
        } catch (e) {
          console.warn('Could not sync content_ids into datatable ajax URL', e);
        }
      }
      oldTable.destroy();
        const reloadPaths = ["/triggers", "/users", "/roles"];
        const path = window.location.pathname;
        if (reloadPaths.some(p => path.endsWith(p))) {
          window.location.reload();
        } 
        else
        {
            render_dataTable();
          if (!$.fn.dataTable.isDataTable($mainTable[0])) {
            return;
          }
          const newTable = $mainTable.DataTable();
            newTable.search(globalSearch);
            newTable.columns().every(function(index) {
            this.search(columnSearch[index] || '');
            });
          newTable.page.len(pageLen);
          newTable.page(pageIndex).draw(false);
            $('#entry-count').text(newTable.rows({ filter: 'applied' }).count());
          newTable.off('draw.trkEntryCount').on('draw.trkEntryCount', function() {
              $('#entry-count').text(newTable.rows({ filter: 'applied' }).count());
            });
      }
  });
    $('.overlay, body').addClass('loaded');
    $('.overlay').css({'display':'none'})
}

window.select2Init = function () {
    $('[data-select2-initialize]').each( function (){
        $(this).select2({
            dropdownParent: $("#shareRecipeModal"),
            closeOnSelect : !$(this)[0].multiple,
            allowClear: true
            // allowHtml: true,

        });
        
    });
    $.fn.select2.defaults.set("width", "100%");
    $('[data-select2-initialize]').on('select2:select', function (e) {
        setTimeout(function() {
          $('.select2-search__field').val('');
        }, 0);
      });
};

window.dateValidation = function (){
    $("#start_date").change(function(){
        var start_date =  $("#start_date").val();
        $("#end_date").prop('min',start_date);
    });
}

window.searchBarCursorPosition = function (){
    var search_field = $('#search_id')[0]
    var start_end_range = search_field.value.length
    search_field.focus();
    search_field.setSelectionRange(start_end_range, start_end_range,"forward");
}

window.checkIfEnableButtons = function($target) {
    if ($('[data-enable-buttons]:checked').length > 0) {
        $target.attr("disabled", false)

    } else {
        $target.attr('disabled',true);

    }
};

$(document).ready(function () {
    $(".nav-item").click(function () {
        $(".dropdown-toggle").removeClass("show");
        $(".profile-bg").removeClass("show");
        // $(".dropdown-toggle").removeClass("active");
        $("ul").removeClass("show");
        $("#navbarDropdownMenuLink").removeAttr("aria-expanded");
    });
});

$(document).on('click', '.trk-global-search-button', function(e) {
    e.preventDefault();
});

$(document).on('blur', 'input[name="v2_user[email]"]', function(e) {
      if ($('input[name="v2_user[email]"]').length) {
        $.ajax({
          url: "/v2/users/update_phone",
          type: "POST",
          headers: {
            "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content") 
          },
          data: {email: $('input[name="v2_user[email]"]').val()},
          success: function (result) {
            if (result[0] == true) {
              $('input[name="v2_user[phone_number]"]').val(result[1])  
            }
            else
             {
               $('input[name="v2_user[phone_number]"]').val(result[1])  
             }     

          }
        })
      }
   })

// Track individual row-checkbox changes at the document level so the set
// survives DataTable destroy/recreate.
$(document).on('change', '.row-checkbox', function() {
  window.__dtSelectedIds = window.__dtSelectedIds || [];
  var rowId = $(this).val();
  if (this.checked) {
    if (window.__dtSelectedIds.indexOf(rowId) === -1) {
      window.__dtSelectedIds.push(rowId);
    }
  } else {
    window.__dtSelectedIds = window.__dtSelectedIds.filter(function(id) {
      return id !== rowId;
    });
    // If the user unchecks a row while "All" is active, the state is no
    // longer "all" — clear the sentinel so draw.dt restoration uses the
    // exact __dtSelectedIds set instead of re-ticking every visible row.
    if ($("input#boxes_checked").val() === 'true') {
      $("input#boxes_checked").val('false');
    }
  }
});

// Restore checkbox state on every DataTables redraw (pagination, sort, length
// change, etc.). Two cases:
//   1) "All" is active (boxes_checked == 'true'): every visible row stays
//      checked. The toggle-all-rows handler uses .prop() without firing
//      change events, so we can't rely on __dtSelectedIds here.
//   2) Individual selections: re-tick only the IDs the user explicitly
//      selected, when those rows reappear on the current page.
$(document).on('draw.dt', function() {
  if ($("input#boxes_checked").val() === 'true') {
    $('table.DataTable tbody .row-checkbox').prop('checked', true);
    $('.btn-action').attr('disabled', false);
  } else if (Array.isArray(window.__dtSelectedIds) && window.__dtSelectedIds.length) {
    var ids = window.__dtSelectedIds;
    $('table.DataTable tbody .row-checkbox').each(function() {
      if (ids.indexOf($(this).val()) !== -1) {
        $(this).prop('checked', true);
      }
    });
    if ($('.row-checkbox:checked').length > 0) {
      $('.btn-action').attr('disabled', false);
    }
  }
});

// Capture currently-checked row IDs BEFORE the trk_datatables wrapper handler
// destroys & re-creates the DataTable (mousedown fires before click, so the
// DOM still has the selected checkboxes at this point).
$(document).on('mousedown', '.trk-global-search-button', function() {
  window.__dtPreservedCheckedIds = $('.row-checkbox:checked').map(function() {
    return $(this).val();
  }).get();
});

$(document).on('click', '.trk-global-search-button', function(e) {
  e.preventDefault();
  const table = $('table.DataTable').DataTable();
  if (table) {
    // Bind a one-time draw listener on the NEW DataTable instance so we can
    // re-tick the previously-selected rows once the AJAX-loaded rows render.
    table.one('draw.dt', function() {
      const ids = window.__dtPreservedCheckedIds || [];
      if (ids.length) {
        $('table.DataTable tbody .row-checkbox').each(function() {
          if (ids.indexOf($(this).val()) !== -1) {
            $(this).prop('checked', true);
          }
        });
        if ($('.row-checkbox:checked').length > 0) {
          $('.btn-action').attr('disabled', false);
        }
      }
    });
    if (/^\/v2\/(contents|playlists|schedules)(\/|$|\?)/.test(window.location.pathname)) {
      table.order([]);
    }
    // The Last Delivery At date-range filter changes the header widths, so
    // re-measure the columns before redrawing.
    table.columns.adjust();
    table.draw();
    $('#entry-count').text(table.rows({ filter: 'applied' }).count());
  }
  const table1 = $('.modal.show').find('table.dataTable').DataTable();
  if (table1) {
    table1.columns.adjust().draw();
  }
});

$(document).on('click', '.toggle-filter-panel', function(e) {
  e.preventDefault();
  $('.filter-panel').toggle();
});
document.addEventListener("turbo:before-cache", function () {
    const table = $('table.DataTable').DataTable();
    if (table) {
      table.destroy();
    }
    // Selection state is intentionally per-visit. Without this reset, the
    // cached DOM keeps checked checkboxes and the global selection set
    // re-ticks them via the draw.dt restorer when the user returns.
    window.__dtSelectedIds = [];
    window.__dtPreservedCheckedIds = [];
    window.__tagSelectedIds = [];
    $("input#boxes_checked").val('false');
    $('.row-checkbox, #toggle-all-rows, [data-enable-buttons]').prop('checked', false);
  });
  $(document).on("click", "#search-clear-btn", function () {
    const table = $('table.DataTable').DataTable();
    if (table) {
        table.search('').draw();
        table.columns().search('').draw();
    }
  });

  $(document).on('draw.dt', function (_e, settings) {
  let table = $(settings.nTable);
  // Identify correct table by header names
  let headers = table.find('th').map(function () {
    return $(this).text().trim();
  }).get();
  if (
    headers.includes('User') &&
    headers.includes('Comment') &&
    headers.includes('Created At')
  ) {
    // Remove DataTables colgroup
    table.find('colgroup').remove();

    // Apply strict widths
    table.prepend(`
      <colgroup>
        <col style="width:15%">
        <col style="width:70%">
        <col style="width:15%">
      </colgroup>
    `);
  }
});
import "@fortawesome/fontawesome-free/js/all";

import './../stylesheets/application.scss'
import './login'

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

window.updateSlider = function(slider) {
  const labelId = slider.dataset.labelId;
  const label = document.getElementById(labelId);
  if (label) {
    const value = slider.value;
    const title = labelId.split("-")[0];
    label.innerText = `${capitalize(title)} : ${value}`;

    const percent = (value - slider.min) / (slider.max - slider.min) * 100;
    slider.style.background = `linear-gradient(to right, #007bff 0%, #007bff ${percent}%, #ccc ${percent}%, #ccc 100%)`;
  }
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Highlight delivery dates in the daterangepicker calendar based on the current page rows
(function () {
  var _deliveryDates = [];

  var _monthNames = [
    'January','February','March','April','May','June',
    'July','August','September','October','November','December'
  ];

  function _collectDates($table) {
    var dates = [];
    $table.find('tbody td span[data-delivery-date]').each(function () {
      var d = $(this).attr('data-delivery-date');
      if (d && dates.indexOf(d) === -1) dates.push(d);
    });
    return dates;
  }

  function _applyHighlights(dates) {
    if (!dates.length) return;
    ['.drp-calendar.left', '.drp-calendar.right'].forEach(function (sel) {
      var $cal = $(sel);
      if (!$cal.length || !$cal.is(':visible')) return;

      var monthText = $cal.find('.month').text().trim();
      var yearMatch = monthText.match(/\d{4}/);
      if (!yearMatch) return;
      var year = parseInt(yearMatch[0]);

      var monthIndex = -1;
      for (var i = 0; i < _monthNames.length; i++) {
        if (monthText.indexOf(_monthNames[i]) !== -1) { monthIndex = i; break; }
      }
      if (monthIndex < 0) return;

      $cal.find('td.available').each(function () {
        var $td = $(this);
        if ($td.hasClass('off')) { $td.removeClass('delivery-date-highlight'); return; }
        var day = parseInt($td.text().trim());
        if (isNaN(day)) { $td.removeClass('delivery-date-highlight'); return; }
        var dateStr = year + '-' +
          String(monthIndex + 1).padStart(2, '0') + '-' +
          String(day).padStart(2, '0');
        $td.toggleClass('delivery-date-highlight', dates.indexOf(dateStr) !== -1);
      });
    });
  }

  // When the calendar opens, capture visible page dates and highlight them
  $(document).on('show.daterangepicker',
    'th[data-datatable-range="datetime"] input',
    function () {
      var $table = $(this).closest('table');
      _deliveryDates = _collectDates($table);
      setTimeout(function () { _applyHighlights(_deliveryDates); }, 0);
    }
  );

  // Re-highlight after navigating months (prev/next arrows in the picker)
  $(document).on('click', '.daterangepicker .prev, .daterangepicker .next', function () {
    setTimeout(function () { _applyHighlights(_deliveryDates); }, 50);
  });
}());
